<script>
    import NavigationHeader from '../NavigationHeader.vue';
    import ButtonIconLeft from '../buttons/ButtonIconLeft.vue';
    import ButtonNormal from '../buttons/ButtonNormal.vue';
    import FileUploader from '../shared/file-uploader/FileUploader';
    import Accordion from '../shared/Accordion';
    import TariffIndicator from '../shared/TariffIndicator';
    import UserService from '@/services/UserService';
    import PhonenumberService from '@/services/PhonenumberService';
    import AccountService from '@/services/AccountService';
    import SupportUserService from '@/services/SupportUserService';
    import FaxUserService from '@/services/FaxUserService';
    import VoicemailboxService from '@/services/VoicemailboxService';
    import FunctionKeySettingsService from '@/services/FunctionKeySettingsService';
    import {NORMAL_USER_PERMISSIONS, SERVICE_ID, INTERNAL_PHONENUMBERS} from '@/services/Constants';
    import Modal from '../shared/Modal.vue';
    import NumberPicker from '../shared/NumberPicker.vue';
    import PasswordInput from '../inputs/PasswordInput';
    import {loadItem, saveItem} from '../../services/Storage.ts';
    import {required, requiredIf, minLength, email, or} from 'vuelidate/lib/validators';
    import {User} from '../../models/User';
    import {BLFuser} from '../../models/BLFuser';
    import { replaceVoicemailAnnouncement } from '@/services/xml-rpc/replaceVoicemailAnnouncementService';
    import utils from '@/services/xml-rpc/utils';
    import { mapGetters } from 'vuex';
    import { createXmlRpcToken } from '@/services/Authentication';
    export default {
        name: 'UserEdit',
        components: {
            NavigationHeader,
            ButtonIconLeft,
            ButtonNormal,
            Modal,
            NumberPicker,
            PasswordInput,
            FileUploader,
            Accordion,
            TariffIndicator
        },
        data() {
            return {
                id: this.$route.params.id,
                user: User,
                editMode: true,
                isIbanSet: false,
                faxUser: User,
                editPassword: true,
                isModalForDeleteVisible: false,
                isModalForUpdateVisible: false,
                isSubmitted: false,
                isSubmittedPopup: false,
                userCount: null,
                userList: [],
                allExternalPhonenumbers: [],
                pickedPhonenumber: null,
                allInternalPhonenumbers: [],
                internalPhonenumberId: null,
                voicemailboxId: null,
                accountInfo: null,
                iban: '',
                data: {
                    firstName: '',
                    familyName: '',
                    email: '',
                    login: '',
                    password: '',
                    language: 'default',
                    missedCallReport: true,
                    faxCoverPage: false,
                    faxEmailJournal: false,
                },
                dataPhonenumbers: [],
                dataOld: {},
                phonenumberOld: null,
                title: 'Benutzer hinzufügen',
                saveButtonTitle: 'Benutzer erstellen',
                freeTarifPrice: 'Möchtest du einen weiteren Benutzer für 2,90 € zzgl. MwSt. pro Monat hinzufügen?',
                completeTarifPrice: 'Möchtest du einen weiteren Benutzer für 4,90 € zzgl. MwSt. pro Monat hinzufügen?',
                mailboxConfig: {
                    title: '',
                    intro: 'Lade hier Deine individuelle Mailboxansage im WAV Format hoch! <a style="color:#F59B00;text-decoration: underline;" href="https://knowledge.starface.de/display/starup/Mailboxansagen" target="_blank">Mehr Info</a>',
                    file: {
                        type: '.wav',
                        selected: false
                    },
                    info: {
                        preFileText: '',
                        fileName: '',
                        selectedFile: ''
                    }
                },
                mailboxAudioFile: null,
                isModalForIbanCheckVisible: false,
            };
        },
        validations: {
            data: {
                firstName: {
                    required,
                },
                familyName: {
                    required,
                },
                email: {
                    required,
                    email,
                },
                password: {
                    required: requiredIf(function() {
                        return this.editPassword;
                    }),
                    passwordLengthIfEdit: or(function() {
                        return !this.editPassword;
                    }, minLength(8)),
                }
            },
            iban: {
                required,
            }
        },
        computed: {
            ...mapGetters({
                isPremium: 'isPremium',
                isTest: 'isTest',
                getActiveUserId: 'getActiveUserId'
            }),
        },
        created() {
            this.editMode = this.id !== undefined;
            PhonenumberService.getAllPhonenumbers().then(responsePhonenumbers => {
                this.getAndSortAllAvailablePhonenumbers(responsePhonenumbers.data);
                UserService.getAllUsers().then(responseGetAllUsers => {
                    const userList = responseGetAllUsers.data;
                    SupportUserService._removeSupportUserFromList(userList);
                    this.faxUser = FaxUserService._findFaxUserFromList(userList);
                    FaxUserService._removeFaxUserFromList(userList);
                    this.userCount = userList.length;
                    this.userList = userList;
                    if (this.editMode) {
                        this.editPassword = false;
                        this.title = 'Benutzer bearbeiten';
                        this.saveButtonTitle = 'Änderungen speichern';
                        UserService.getUserById(this.id).then(responseGetUser => {
                            this.fillForm(responseGetUser.data);
                            this.dataOld = Object.assign({}, this.data);

                            VoicemailboxService.getAllVoicemailboxes().then(response => {
                                if (response.data && response.data.length > 0) {
                                    this.getVoicemailboxIdForUser(response.data, this.dataOld.familyName, this.dataOld.firstName);
                                }
                            });
                        });
                    } else {
                        this.setDefaultPhonenumber();
                        this.getAccount();
                    }
                });
            });
        },
        methods: {
            getVoicemailboxIdForUser(voicemailboxes, familyName, firstName) {
                for (const voicemailbox of voicemailboxes) {
                    if (voicemailbox.assignedusers.length > 0) {
                        const name = voicemailbox.assignedusers[0].split(', ');
                        if (name[0] === familyName  && name[1] === firstName) {
                            this.voicemailboxId = voicemailbox.id;
                        }
                    }
                }
            },
            findIdOfNewUserByLogin(userList) {
                for (const user of userList) {
                    if (user.login === this.data.login) {
                        this.user = user;
                        this.id = user.id;
                    }
                }
            },
            checkIfUserInfoChanged() {
                if (
                    this.data.firstName === this.dataOld.firstName &&
                    this.data.familyName === this.dataOld.familyName &&
                    this.data.email === this.dataOld.email &&
                    this.data.login === this.dataOld.login &&
                    !this.editPassword
                ) {
                    return false;
                } else {
                    return true;
                }
            },
            getAccount() {
                AccountService.getAccount().then(responseAccount => {
                    if (responseAccount.data != null) {
                        this.accountInfo = responseAccount.data;
                        this.checkIfIbanIsSet();
                    }
                });
            },
            checkIfIbanIsSet() {
                if (this.accountInfo.iban !== '') {
                    this.isIbanSet = true;
                }
            },
            closeModalForDelete() {
                this.isModalForDeleteVisible = false;
            },
            confirmModalForDelete() {
                this.isModalForDeleteVisible = false;
                UserService.deleteUser(this.id)
                .then(() => {
                    FunctionKeySettingsService.deleteBLFforAllUsers(+this.id, this.userList);
                    if (this.voicemailboxId) {
                        VoicemailboxService.deleteVoicemailbox(this.voicemailboxId)
                        .then(() => {
                                this.$toasted.global.starface_success({
                                    message: 'Benutzer wurde gelöscht',
                                    icon: 'USER',
                                });
                                this.$router.push('/');
                        })
                        .catch(error => {
                            this.$toasted.global.starface_error({
                                message: 'Mailbox konnte nicht gelöscht werden',
                                icon: 'USER',
                            });
                            this.$router.push('/');
                        });
                    } else {
                        this.$toasted.global.starface_success({
                            message: 'Benutzer wurde gelöscht',
                            icon: 'USER',
                        });
                        this.$router.push('/');
                    }
                })
                .catch(error => {
                    this.$toasted.global.starface_error({
                        message: 'Benutzer konnte nicht gelöscht werden',
                        icon: 'USER',
                    });
                });
            },
            closeModalForUpdate() {
                this.isModalForUpdateVisible = false;
            },
            confirmModalForUpdate() {
                this.isModalForUpdateVisible = false;
                this.data.login = this.pickedPhonenumber.phoneNumberForLogin;
                if (this.editMode) {
                    this.updateUser();
                } else {
                    this.createNewUser();
                }
            },
            setPhonenumbersForUser() {
                for (const phonenumber of this.allExternalPhonenumbers) {
                    if (phonenumber.id === this.pickedPhonenumber.id) {
                        this.dataPhonenumbers = [{
                            accountId: this.id,
                            phoneNumberId: phonenumber.id,
                            serviceId: SERVICE_ID.StandardCallUser,
                        }];
                        break;
                    }
                }
                if (!this.editMode) {
                    this.dataPhonenumbers.push({
                        accountId: this.id,
                        phoneNumberId: this.internalPhonenumberId,
                        serviceId: SERVICE_ID.StandardCallUser,
                    });
                }
            },
            setDefaultPhonenumber() {
                for (const entry of this.allExternalPhonenumbers) {
                    if (this.pickedPhonenumber === null && entry.available) {
                        this.pickedPhonenumber = entry;
                        break;
                    }
                }
            },
            getAndSortAllAvailablePhonenumbers(responsePhonenumbers) {
                const {
                    external,
                    internal,
                    internalPhoneNumberId,
                } = PhonenumberService.splitAndSortNumbers(
                    responsePhonenumbers,
                    this.internalPhonenumberId,
                );
                this.allExternalPhonenumbers = external;
                this.allInternalPhonenumbers = internal;
                if (!this.editMode) {
                    this.internalPhonenumberId = internalPhoneNumberId;
                }
            },
            fillForm(user) {
                this.data.firstName = user.firstName;
                this.data.familyName = user.familyName;
                this.data.email = user.email;
                this.data.login = user.login;
                this.data.password = user.password;
                for (const phonenumber of this.allExternalPhonenumbers) {
                    if (String(phonenumber.assignedUserAccountId) === this.id) {
                        phonenumber.available = true;
                        this.pickedPhonenumber = phonenumber;
                        this.phonenumberOld = phonenumber;
                        break;
                    }
                }
                if (this.pickedPhonenumber === null) {
                    this.pickedPhonenumber = {
                        phoneNumberComplete: '',
                        phoneNumberForLogin: '',
                        phonenumber: 'Keine Nummer zugewiesen',
                        phonenumberExtension: '',
                        phonenumberForForm: '',
                        assignedGroupAccountId: null,
                        assignedUserAccountId: null,
                        assignedServiceId: null,
                        available: false,
                        id: null
                    };
                    this.phonenumberOld = this.pickedPhonenumber;
                }
                for (const phonenumber of this.allInternalPhonenumbers) {
                    if (String(phonenumber.assignedUserAccountId) === this.id) {
                        this.internalPhonenumberId = phonenumber.id;
                        break;
                    }
                }
            },
            transformDataForPutRequest() {
                const dataForPutRequest = {
                    firstName: this.data.firstName,
                    familyName: this.data.familyName,
                    email: this.data.email,
                    login: this.data.login,
                    language: 'default',
                };
                if (this.editPassword) {
                    dataForPutRequest.password = this.data.password;
                }
                this.data = dataForPutRequest;
            },
            updateBLFforUsers() {
                if ((this.data.firstName !== this.dataOld.firstName)
                    || (this.data.familyName !== this.dataOld.familyName)) {
                    FunctionKeySettingsService.updateBLFforAllUsers(
                        new BLFuser(+this.id, this.data.firstName, this.data.familyName), this.userList);
                }
            },
            createNewUser() {
                this.updateFaxConfiguration();
                UserService.createUser(this.data)
                .then(responsePost => {
                    UserService.getAllUsers().then(responseGetAllUsers => {
                        this.findIdOfNewUserByLogin(responseGetAllUsers.data);
                        this.setPhonenumbersForUser();
                        UserService.assignPhonenumbersForUser(
                            this.id,
                            this.dataPhonenumbers,
                        ).then(response => {
                            UserService.revokeUserLogin(this.id, NORMAL_USER_PERMISSIONS);
                        }).then(responsePostNumbers => {
                            VoicemailboxService.createVoicemailbox(
                                this.getCreateVoiceMailboxData()
                            ).then(responseVoicemailbox => {
                                VoicemailboxService.getAllVoicemailboxes().then(response => {
                                    if (response.data && response.data.length > 0) {
                                        this.getVoicemailboxIdForUser(response.data, this.data.familyName, this.data.firstName);
                                        this.saveMailboxAnnouncement('Benutzer erfolgreich hinzugefügt');
                                    }
                                });
                                this.$router.push('/');
                            })
                            .catch(error => {
                                this.$toasted.global.starface_error({
                                    message: 'Benutzer konnte nicht erstellt werden',
                                    icon: 'USER',
                                });
                            });
                        });
                        FunctionKeySettingsService.setButtonForMailBoxConfiguration(+this.id);
                        FunctionKeySettingsService.setBLFforAllUsers(this.user, responseGetAllUsers.data);
                    });
                })
                .catch(error => {
                    this.$toasted.global.starface_error({
                        message: 'Benutzer konnte nicht erstellt werden',
                        icon: 'USER',
                    });
                });
            },
            updateUser() {
                this.updateActiveUserPassword();
                this.updateUserData();
                this.updateUserPhoneNumber();
                this.updateUserMailbox();
            },
            updateUserData() {
                if (this.checkIfUserInfoChanged()) {
                    this.updateBLFforUsers();
                    this.transformDataForPutRequest();
                    UserService.updateUser(this.id, this.data)
                    .then(responsePost => {
                        if (this.phonenumberOld.phoneNumberForLogin === loadItem('loginId')) {
                            saveItem('loginId', this.pickedPhonenumber.phoneNumberForLogin, false);
                        }
                    })
                    .catch(error => {
                        this.$toasted.global.starface_error({
                            message: 'Benutzer konnte nicht aktualisiert werden',
                            icon: 'USER',
                        });
                    });
                }
            },
            updateUserPhoneNumber() {
                if (this.pickedPhonenumber.id !== this.phonenumberOld.id) {
                    this.setPhonenumbersForUser();
                    UserService.deleteUsersPhonenumber(
                        this.id,
                        this.phonenumberOld.id,
                    )
                    .then(responseDelete => {
                        UserService.assignPhonenumbersForUser(
                            this.id,
                            this.dataPhonenumbers,
                        )
                        .then(() => {
                            this.updateBLFforUsers();
                        })
                        .catch(error => {
                            this.$toasted.global.starface_error({
                                message: 'Benutzer konnte nicht aktualisiert werden',
                                icon: 'USER',
                            });
                        });
                    })
                    .catch(error => {
                        this.$toasted.global.starface_error({
                            message: 'Benutzer konnte nicht aktualisiert werden',
                            icon: 'USER',
                        });
                    });
                }
            },
            updateActiveUserPassword() {
                if (this.id === this.getActiveUserId.toString()) {
                    createXmlRpcToken(this.pickedPhonenumber.phoneNumberForLogin, this.data.password);
                }
            },
            updateUserMailbox() {
                if (this.checkIfUserInfoChanged() || this.pickedPhonenumber.id !== this.phonenumberOld.id || this.mailboxAudioFile !== null) {
                    if (this.voicemailboxId != null) {
                        VoicemailboxService.updateVoicemailbox(
                            this.getUpdateVoiceMailboxData()
                        ).then(() => {
                            this.saveMailboxAnnouncement('Änderungen gespeichert');
                        })
                        .catch(error => {
                            this.$toasted.global.starface_error({
                                message: 'Voicemailbox konnte nicht aktualisiert werden',
                                icon: 'USER',
                            });
                        });
                    } else {
                        VoicemailboxService.createVoicemailbox(
                            this.getCreateVoiceMailboxData()
                        ).then(() => {
                                if (this.mailboxAudioFile) {
                                    VoicemailboxService.getAllVoicemailboxes().then(response => {
                                        if (response.data && response.data.length > 0) {
                                            this.getVoicemailboxIdForUser(response.data, this.data.familyName, this.data.firstName);
                                            this.saveMailboxAnnouncement('Änderungen gespeichert');
                                        }
                                    });
                                } else {
                                    this.$router.push('/');
                                }
                        })
                        .catch(error => {
                            this.$toasted.global.starface_error({
                                message: 'Voicemailbox konnte nicht aktualisiert werden',
                                icon: 'USER',
                            });
                        });
                    }
                }
            },
            saveUser() {
                this.isSubmitted = true;
                if (!this.$v.data.$invalid) {
                    if (this.editMode) {
                        this.isModalForUpdateVisible = true;
                    } else {
                        if (!this.isTest) {
                            this.isModalForIbanCheckVisible = true;
                        } else {
                            this.data.login = this.pickedPhonenumber.phoneNumberForLogin;
                            this.createNewUser();
                        }
                    }
                } else {
                    this.$toasted.global.starface_error({
                        message: 'Bitte fülle alle Felder korrekt aus.',
                        icon: 'USER',
                    });
                }
            },
            deleteUser() {
                this.isModalForDeleteVisible = true;
            },
            updateFaxConfiguration() {
                if (this.faxUser) {
                    this.data.faxHeader = this.faxUser.faxHeader;
                    this.data.faxCallerId = this.faxUser.faxCallerId;
                }
            },
            uploadMailboxFile(event) {
                const file = event.target.files[0];
                if (file) {
                    this.mailboxConfig.file.selected = true;
                    this.mailboxConfig.info.selectedFile = file.name;
                    utils.getBase64(file).then(
                        data => {
                            this.mailboxAudioFile = data;
                        }
                    );
                }
            },
            saveMailboxAnnouncement(message) {
                if (this.mailboxAudioFile) {
                    VoicemailboxService.getVoicemailboxById(this.voicemailboxId).then( resp => {
                        replaceVoicemailAnnouncement({mailbox: '*9' + resp.data.number, audio: this.mailboxAudioFile}).then( voicemailResponse => {
                            if (voicemailResponse.data.Success) {
                                    this.showToastAndNavigate(message);
                            } else {
                                // message ? this.$toasted.global.starface_success({message: message, icon: 'USER'}) : '';
                            }
                        });
                    });
                } else {
                    this.showToastAndNavigate(message);
                }
            },
            showToastAndNavigate(message) {
                message ? this.$toasted.global.starface_success({message: `${message}`, icon: 'USER'}) : '';
                this.$router.push('/');
            },
            getCreateVoiceMailboxData() {
                // maximumDuration: -1 represents 10 min of voicemail Aufzeichnungsdauer
                return {
                    maximumDuration: -1,
                    name: 'Voicemailbox ' + this.pickedPhonenumber.phonenumberExtension,
                    noRecord: false,
                    number: this.pickedPhonenumber.phonenumberExtension,
                    password: '',
                    voicemailUsers: [{
                        accountId: this.id,
                        name: this.data.familyName + ', ' + this.data.firstName,
                        sendMail: true,
                        voicemailboxName: 'Voicemailbox ' + this.pickedPhonenumber.phonenumberExtension
                    }],
                    voicemailGroups: []
                };
            },
            getUpdateVoiceMailboxData() {
                return Object.assign({}, this.getCreateVoiceMailboxData(), {id: this.voicemailboxId});
            },
            closeModalForIbanCheck() {
                this.isModalForIbanCheckVisible = false;
            },
            confirmModalForIbanCheck() {
                this.data.login = this.pickedPhonenumber.phoneNumberForLogin;
                if (!this.isIbanSet) {
                    this.saveIban();
                }
                if (this.isIbanSet) {
                    this.isModalForIbanCheckVisible = false;
                    this.createNewUser();
                }
            },
            saveIban() {
                this.isSubmittedPopup = true;
                if (!this.$v.iban.$invalid) {
                    this.accountInfo.iban = this.iban;

                    AccountService.updateAccount(this.accountInfo).then(responseAccount => {
                        if (responseAccount.data.success != null) {
                            this.isModalForIbanCheckVisible = false;
                            this.getAccount();
                            this.createNewUser();
                        } else {
                            this.$toasted.global.starface_error({
                                message: 'IBAN konnte nicht gespeichert werden. Bitte überprüfe Deine IBAN.',
                                icon: 'USER',
                            });
                        }
                    })
                    .catch(error => {
                        this.$toasted.global.starface_error({
                            message: 'IBAN konnte nicht gespeichert werden.',
                            icon: 'USER',
                        });
                    });
                }

            },
        },
    };
</script>

<template>
    <div class="container">
        <div id="user-edit">
            <NavigationHeader route="/users" navigationText="zurück zur Übersicht" :title="title"/>
            <div class="wrapper">
                <form class="form">
                    <div class="account-info">
                        <div class="form-group form-text firstName">
                            <label for="firstName">Vorname:</label>
                            <input class="form-control" type="text" name="firstName" id="firstName"
                                   v-bind:class="{ 'has-error': isSubmitted && $v.data.firstName.$invalid }"
                                   v-model="data.firstName" required/>
                            <span class="error-message" v-if="isSubmitted && $v.data.firstName.$invalid">Bitte gebe einen Vornamen ein.</span>
                        </div>
                        <div class="form-group form-text familyName">
                            <label for="familyName">Nachname:</label>
                            <input class="form-control" type="text" name="familyName" id="familyName"
                                   v-bind:class="{ 'has-error': isSubmitted && $v.data.familyName.$invalid }"
                                   v-model="data.familyName" required/>
                            <span class="error-message" v-if="isSubmitted && $v.data.familyName.$invalid">Bitte gebe einen Nachnamen ein.</span>
                        </div>
                        <div class="form-group form-text email">
                            <label for="email">E-Mail-Adresse:</label>
                            <input class="form-control" type="text" name="email" id="email" v-model="data.email"
                                   v-bind:class="{ 'has-error': isSubmitted && $v.data.email.$invalid }"
                                   @input="$v.data.email.$touch()" required/>
                            <span class="error-message" v-if="isSubmitted && $v.data.email.$invalid">Bitte gebe eine korrekte E-Mail-Adresse ein.</span>
                        </div>
                        <div class="form-group form-text login">
                            <label for="login">Login-ID:</label>
                            <input v-if="pickedPhonenumber" class="form-control" type="text" name="login" id="login"
                                   v-model="pickedPhonenumber.phoneNumberForLogin" required readonly/>
                        </div>
                        <template v-if="!editPassword">
                            <div class="form-group form-text password">
                                <label>Passwort:</label>
                                <div class="change" @click="editPassword=true">Passwort ändern</div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="form-group form-text password">
                                <PasswordInput class="password-input" :label="'Passwort (mindestens 8 Zeichen)'"
                                               :has-error="isSubmitted && $v.data.password.$invalid"
                                               v-model="data.password" :v="$v.data.password"/>
                                <span class="error-message" v-if="isSubmitted && $v.data.password.$invalid">Bitte gebe ein Passwort mit mindestens 8 Zeichen ein.</span>
                            </div>
                        </template>
                    </div>
                    <div class="phone-numbers">
                        <div class="title">Persönliche Rufnummer</div>
                        <NumberPicker v-if="pickedPhonenumber" :numbers="allExternalPhonenumbers" :max-height="'200px'"
                                      :columns="4" :defaultValue="pickedPhonenumber" v-model="pickedPhonenumber"/>
                    </div>
                </form>

                <TariffIndicator title="Weitere Funktionen" :show="!isPremium"/>

                <Accordion title="Mailboxansage" :disabled="!isPremium">
                    <FileUploader :config="mailboxConfig" @uploadFile="uploadMailboxFile"/>
                </Accordion>
                <div class="footer">
                    <div class="left">
                        <ButtonIconLeft v-if="editMode" class="btn-delete" @onClick="deleteUser"
                                        buttonTitle="Benutzer löschen" src="delete" cssClass="btn btn-tertiary"/>
                    </div>
                    <div class="right">
                        <ButtonNormal @onClick="saveUser" class="btn-save" :buttonTitle="saveButtonTitle"
                                      cssClass="btn btn-primary"/>
                        <ButtonNormal @onClick="$router.push('/users')" class="btn-cancel" buttonTitle="Abbrechen"
                                      cssClass="btn btn-secondary"/>
                    </div>
                </div>
            </div>
        </div>
        <Modal v-show="isModalForUpdateVisible" @close="closeModalForUpdate"
               @confirm="confirmModalForUpdate" confirmationButtonText="Speichern">
            <template slot="header">
                Möchtest Du die Änderungen wirklich speichern?
            </template>
        </Modal>
        <Modal v-show="isModalForDeleteVisible" :is-red="true" @close="closeModalForDelete"
               @confirm="confirmModalForDelete">
            <template slot="header">
                Möchtest Du diesen Benutzer wirklich löschen?
            </template>
        </Modal>
        <Modal v-show="isModalForIbanCheckVisible" confirmationButtonText="Kostenpflichtig hinzufügen" @close="closeModalForIbanCheck" @confirm="confirmModalForIbanCheck">
            <template slot="header">
                <span v-if="isPremium">{{ completeTarifPrice }}</span>
                <span v-else>{{ freeTarifPrice }}</span>
            </template>
            <template slot="body">
                <div class="iban-modal">
                    <form  v-if="!isIbanSet" class="form">
                        <p>Für das Hinzufügen eines weiteren Benutzers benötigen wir Deine Bankverbindung.<br> Bitte trage hier Deine IBAN ein:</p>
                        <div class="form-group form-text iban">
                            <label for="iban">IBAN:</label>
                            <input class="form-control" type="text" name="iban" id="iban"
                                   v-bind:class="{ 'has-error': isSubmittedPopup && $v.iban.$invalid }"
                                   v-model="iban" required/>
                            <span class="error-message" v-if="isSubmittedPopup && $v.iban.$invalid">Bitte gebe Deine IBAN ein.</span>
                        </div>
                    </form>
                </div>
             </template>
        </Modal>
    </div>
</template>

<style lang="scss" scoped>
    @import '../../assets/scss/variables.scss';
    @import '../../assets/scss/buttons.scss';
    @import '../../assets/scss/general.scss';
    @import '../../assets/scss/forms.scss';
    @import '../../assets/scss/inputs.scss';
    @import '../../assets/scss/grid.scss';

    #user-edit {
        .wrapper {
            form {
                .account-info {
                    display: grid;
                    display: -ms-grid;
                    grid-template-columns: 1fr 15px 1fr;
                    -ms-grid-columns: 1fr  15px 1fr;
                    .firstName {
                        grid-row: 1;
                        -ms-grid-row: 1;
                        grid-column: 1;
                        -ms-grid-column: 1;
                    }
                    .familyName {
                        grid-row: 2;
                        -ms-grid-row: 2;
                        grid-column: 1;
                        -ms-grid-column: 1;
                    }
                    .email {
                        grid-row: 3;
                        -ms-grid-row: 3;
                        grid-column: 1;
                        -ms-grid-column: 1;
                    }
                    .login {
                        grid-row: 1;
                        -ms-grid-row: 1;
                        grid-column: 3;
                        -ms-grid-column: 3;
                    }
                    .password {
                        grid-row: 2 / span 2;
                        -ms-grid-row: 2;
                        grid-column: 3;
                        -ms-grid-column: 3;
                        .password-input {
                            margin-bottom: 0;
                        }
                        .change {
                            color: $orange;
                            cursor: pointer;
                        }
                    }
                    .btn-tertiary {
                        background-color: transparent;
                        border: none;
                        color: $orange;
                        font-size: 18px;
                    }
                }
                .phone-numbers {
                    margin-bottom: 50px;
                    .title {
                        font-weight: bold;
                        margin-bottom: 12px;
                    }
                }
            }
            .footer {
                display: grid;
                display: -ms-grid;
                grid-template-columns: 1fr 1fr;
                -ms-grid-columns: 1fr 1fr;
                .left {
                    @extend .grid-column-1;
                }
                .right {
                    display: inline-block;
                    grid-column: 2;
                    -ms-grid-column: 2;
                    .btn-cancel {
                        max-width: 45%;
                        float: right;
                        margin-right: 25px;
                    }
                    .btn-save {
                        max-width: 45%;
                        float: right;
                    }
                }
            }
        }
    }
    .modal-paying-user {
        a {
            color: $orange;
            display: flex;
            align-items: center;
            img {
                margin-right: 15px;
            }
            b {
                padding-right: 8px;
            }
        }
    }
    .button {
        margin: 16px;
    }
    .error-message {
        font-size: 12px;
        font-weight: 600;
        text-align: left;
        color: $red;
    }
    .has-error {
        border-color: #f54d00;
    }
    .bodyOfCostsModal {
        width: 650px;
    }
</style>
